import { useState, useEffect } from 'react';
import { getInterviews } from '../lib/interviewsClient';

export const useMatchRequests = () => {
  const [pendingCount, setPendingCount] = useState(0);
  const [pendingRequests, setPendingRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lastFetch, setLastFetch] = useState(null);

  const fetchMatchRequests = async (forceRefresh = false) => {
    // Only fetch if we haven't fetched recently (within 30 seconds) unless forced
    const now = Date.now();
    if (!forceRefresh && lastFetch && (now - lastFetch) < 30000) {
      return;
    }

    try {
      const interviews = await getInterviews({ forceRefresh });

      const matchRequests = (interviews || []).filter(
        (interview) => interview.fields["Stage"] === "Match requested"
      );

      // Transform the data to include additional fields for easier consumption
      const transformedRequests = matchRequests.map((interview) => ({
        id: interview.id,
        roleTitle: interview.fields["Role Title (from Role)"] || "Unknown Role",
        companyName: interview.fields["Name (from Startup) (from Role)"] || "Unknown Company",
        roleImage: interview.fields["Role Cover Image (from Startup) (from Role)"]?.[0]?.url || 
                  "https://placehold.co/400x300/e2e8f0/64748b?text=No+Image",
        compensation: interview.fields["Compensation (from Role)"] || "Not specified",
        location: interview.fields["Location (from Startup) (from Role)"] || "Location not specified",
        fundingStage: interview.fields["Funding Stage (from Startup) (from Role)"] || "Not specified",
        // Add founder's message and URL ID for navigation
        founderMessage: interview.fields["Match request direct message text"] || "",
        urlId: interview.fields["URL ID (from Role)"] || "",
        // Keep the original interview data for backward compatibility
        originalData: interview
      }));

      setPendingCount(matchRequests.length);
      setPendingRequests(transformedRequests);
      setLastFetch(now);
    } catch (error) {
      console.error("Error fetching match requests:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMatchRequests();
  }, []);

  const refreshMatchRequests = () => {
    fetchMatchRequests(true);
  };

  return {
    pendingCount,
    pendingRequests,
    loading,
    refreshMatchRequests
  };
}; 